<template>
	<div class="item-content">
		<div class="item-title primary-font-color">
			{{ title }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'FormulaTitle',
	props: { title: { type: String } },
};
</script>
<style lang="scss" scoped>
.item-content {
	&:hover {
		background: #f8f9ff;
	}
	.item-title {
		font-size: 12px;
	}
}
</style>
